/**
 * SolutionMechanismsTab — T26.
 * Per-product library editor for the 'solution_mechanism' parameter type.
 */
import LibraryEditor from './LibraryEditor';

interface SolutionMechanismsTabProps {
  canWrite: boolean;
}

export default function SolutionMechanismsTab({ canWrite }: SolutionMechanismsTabProps) {
  return <LibraryEditor type="solution_mechanism" canWrite={canWrite} perProduct />;
}
